import { useDispatch, useSelector } from 'react-redux';
import { userForgotDetailsActionV2 } from '../../../store/actions/UserActions';
import { useEffect, useRef, useState } from 'react';
import fecha from 'fecha';
import { isValidEmail, isValidMobile } from '../../../../../constants/Validators';
import {config, service} from '../../../../needHelp/utils';

const initialStates = {
  disabledByEmail: true,
  disabledByDOB: true,
  rotate: false,
  month: new Date(),
};

export function useForgotUserNameContainer(props) {
  const [ state, setState ] = useState(initialStates);
  const [ validationFail, setValidationFail ] = useState(false);
  const [ contactDetailsEntered, setContactDetailsEntered ] = useState('');
  const [ dobSelected, setDobSelected ] = useState('');
  const dispatch = useDispatch();
  const { user: { forgotDetails } } = useSelector((state: any) => {
    return state;
  });
  const timerRef = useRef(null);
  const [ showModal, setShowModal ] = useState(props.showModal || false);

  useEffect(() => {
    if (forgotDetails && contactDetailsEntered) {
      decideNextPage(forgotDetails);
    }
    return () => {
      clearTimeout(timerRef.current);
    };
  }, [ forgotDetails ]);

  const decideNextPage = (forgotDetails) => {
    const userForgotDetails = { ...forgotDetails, emailEntered: contactDetailsEntered };
    if (forgotDetails.error) {
      setValidationFail(true);
      props.switchModal('failureWrongDetails', userForgotDetails);
    } else {
      props.switchModal('getUsernameSuccess', userForgotDetails);
    }
  };

  const onDateChange = (date) => {
    setState({
      ...state,
      disabledByDOB: false,
    });
    setDobSelected(fecha.format(date, 'YYYYMMDD'));
  };

  const closeModal = () => {
    setShowModal(false);
    props.closeModal();
  };

  const handleInputKeyUpViaParent=(val) => {
    if (val && val.length > 0) {
      setState({
        ...state,
      });
      setContactDetailsEntered(val);
    }
    if (isValidEmail(val) || isValidMobile(val)) {
      setState({
        ...state,
        disabledByEmail: false,
      });
    } else {
      setState({
        ...state,
        disabledByEmail: true,
      });
    }
  };

  const rotateLoader = () => {
    service.trackClick(config.NEED_HELP_TRACKING.NEED_HELP, config.CTA_TRACKING_ID.FORGOT_USERNAME);
    if (!(state.disabledByEmail || state.disabledByDOB)) {
      setState({
        ...state,
        rotate: true,
      });

      const queryParams = { email: isValidEmail(contactDetailsEntered)?contactDetailsEntered:'',
        mobile: isValidMobile(contactDetailsEntered)?contactDetailsEntered:'',
        dob: dobSelected };

      dispatch(userForgotDetailsActionV2('U', queryParams));
      timerRef.current = setTimeout(() => {
        setState({
          ...state,
          rotate: false,
        });
      }, 1500);
    } else {
      // do nothing
    }
  };

  const handleYearMonthChange = (month) => {
    setState({
      ...state,
      month,
    });
  };

  return {
    data: {
      state,
      showModal,
      emailEntered: contactDetailsEntered,
      dobSelected,
      validationFail
    },

    action: {
      rotateLoader,
      handleInputKeyUpViaParent,
      closeModal,
      onDateChange,
      handleYearMonthChange,
    },
  };

}
